var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonthlyPayerFlat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_105_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 77,
    width: 406,
    height: 123,
    fill: "#FF8080"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M446 220H43V481H313.136C296.805 461.143 287 435.717 287 408C287 344.487 338.487 293 402 293C417.585 293 432.446 296.1 446 301.718V220Z",
    fill: "#FFF9F0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.3633 54.3633C62.6192 54.3633 47.5199 60.6176 36.3871 71.7504C25.2543 82.8832 19 97.9825 19 113.727V445.27C19 477.947 45.6861 504.633 78.3633 504.633H339.628C329.487 498.074 320.444 489.962 312.836 480.633H78.3633C58.9409 480.633 43 464.692 43 445.27V113.727C43 104.348 46.7258 95.3529 53.3577 88.721C59.9896 82.0891 68.9844 78.3633 78.3633 78.3633H409.906C419.285 78.3633 428.28 82.0891 434.912 88.721C441.544 95.3529 445.27 104.348 445.27 113.727V301.418C453.832 304.898 461.881 309.379 469.27 314.717V113.727C469.27 97.9825 463.015 82.8832 451.883 71.7504C440.75 60.6176 425.651 54.3633 409.906 54.3633H78.3633Z",
    fill: "#2C2B3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357 23.2191C357 13.3353 348.554 6 339 6C329.446 6 321 13.3353 321 23.2191V111.781C321 121.665 329.446 129 339 129C348.554 129 357 121.665 357 111.781V23.2191Z",
    fill: "#DFDFDF",
    stroke: "#2C2B3D",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167 23.2191C167 13.3353 158.554 6 149 6C139.446 6 131 13.3353 131 23.2191V111.781C131 121.665 139.446 129 149 129C158.554 129 167 121.665 167 111.781V23.2191Z",
    fill: "#DFDFDF",
    stroke: "#2C2B3D",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 208.453H457.27",
    stroke: "#2C2B3D",
    strokeWidth: 24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 402,
    cy: 408,
    r: 95.0948,
    fill: "#70C893",
    stroke: "#2C2B3D",
    strokeWidth: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.806 344.765V470.587",
    stroke: "#2C2B3D",
    strokeWidth: 18,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.261 363.638H386.078C380.238 363.638 374.637 365.958 370.508 370.087C366.379 374.217 364.059 379.817 364.059 385.657C364.059 391.497 366.379 397.097 370.508 401.227C374.637 405.356 380.238 407.676 386.078 407.676H417.533C423.373 407.676 428.974 409.996 433.103 414.125C437.232 418.254 439.552 423.855 439.552 429.695C439.552 435.534 437.232 441.135 433.103 445.264C428.974 449.394 423.373 451.713 417.533 451.713H364.059",
    stroke: "#2C2B3D",
    strokeWidth: 18,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134 282C129.582 282 126 285.582 126 290V319.833C126 324.252 129.582 327.833 134 327.833H163.833C168.252 327.833 171.833 324.252 171.833 319.833V290C171.833 285.582 168.252 282 163.833 282H134ZM134 377C129.582 377 126 380.582 126 385V414.833C126 419.252 129.582 422.833 134 422.833H163.833C168.252 422.833 171.833 419.252 171.833 414.833V385C171.833 380.582 168.252 377 163.833 377H134ZM221 385C221 380.582 224.582 377 229 377H258.833C263.252 377 266.833 380.582 266.833 385V414.833C266.833 419.252 263.252 422.833 258.833 422.833H229C224.582 422.833 221 419.252 221 414.833V385ZM316 290C316 285.582 319.582 282 324 282H353.833C358.252 282 361.833 285.582 361.833 290V300.209C346.101 306.074 331.999 315.284 320.391 326.975C317.786 325.656 316 322.953 316 319.833V290ZM229 282C224.582 282 221 285.582 221 290V319.833C221 324.252 224.582 327.833 229 327.833H258.833C263.252 327.833 266.833 324.252 266.833 319.833V290C266.833 285.582 263.252 282 258.833 282H229Z",
    fill: "#2C2B3D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_105_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512.001,
    height: 512.001,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonthlyPayerFlat);
export default __webpack_public_path__ + "static/media/monthly-payer-flat.d1292e666df74c31c1820a0317ffbc37.svg";
export { ForwardRef as ReactComponent };